// @flow

import React from "react";
import styles from "./iframeWrapper.scss";
import Loader from "../../commons/loader/loader";

type Props = {
  utils?: Object,
  url?: string,
  isFetching?: boolean,
  loadingMsg?: string
};

const IframeWrapper = (props: Props) => (
  <div className={styles.iframeWrapper}>
    {!props.isFetching && props.url ? (
      <div className={styles.iframeContainer}>
        <iframe
          title={(props.utils && props.utils.title) || "Iframe Wrapper"}
          src={props.url}
          width={props.utils.width}
          height={props.utils.height}
        />
      </div>
    ) : (
      <Loader message={props.loadingMsg} />
    )}
  </div>
);

IframeWrapper.defaultProps = {
  url: null,
  isFetching: true,
  utils: {
    title: "Iframe wrapper",
    width: "100%",
    height: "100%"
  },
  loadingMsg: "Loading..."
};

export default IframeWrapper;



// WEBPACK FOOTER //
// ./app/components/commons/iframeWrapper/iframeWrapper.js